import { UserDetails } from './../../models/userDetail.model';
import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { FormControl, AbstractControl } from '@angular/forms';
import { OPTIONAL } from '../../constants/constant';
import * as _ from 'lodash';

@Component({
  selector: 'app-search-single-user',
  templateUrl: './search-single-user.component.html',
  styleUrls: ['./search-single-user.component.scss', '../input-textbox/input-textbox.component.scss']
})
export class SearchSingleUserComponent implements OnInit, OnChanges {

  @Input() labelName: string;
  @Input() subLabelName: string;
  @Input() inputFormControl: FormControl;
  @Input() placeHolder = 'Input Field Text';
  @Input() submitted = false;
  @Input() readOnlyMode = false;
  @Input() users: UserDetails[];
  @Input() showOptionalLabel = true;
  @Input() labelTextTransformNone = false;
  @Output() onSelectUser = new EventEmitter();
  model: any;
  searchTxt = '';
  OPTIONAL = OPTIONAL;
  usersList: UserDetails[];
  hideList = false;

  constructor() { }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.users && changes.users.currentValue) {
      this.users = changes.users.currentValue;
      this.usersList = _.cloneDeep(this.users);
    }
    if (changes.inputFormControl && changes.inputFormControl.currentValue) {
      this.inputFormControl.valueChanges.subscribe(response => {
        this.searchTxt = response;
        this.getUsers();
        this.hideList = false;
        this.onSelectUser.emit(null);
      });
    }
  }

  ngOnInit(): void {
  }

  get isRequiredField(): boolean {
    if (!this.inputFormControl || !this.inputFormControl.validator) {
      return false;
    }

    const validator = this.inputFormControl.validator({} as AbstractControl);
    return (validator && validator.required);
  }

  public getUsers(): void{
    if(this.searchTxt) {
      this.users = this.usersList.filter(item => {
        return (item.displayName || '').toLowerCase().includes(this.searchTxt.toLowerCase()) ||
          (item.loginName && item.loginName.toLowerCase().includes(this.searchTxt.toLowerCase()));
      });
    }
  }

  public onSelect(user: UserDetails): void {
    this.searchTxt = `${user.firstName} ${user.lastName}`;
    this.inputFormControl.setValue(this.searchTxt);
    this.onSelectUser.emit(user);
    this.hideList = true;
  }

  public clear(): void {
    this.searchTxt = null;
    this.inputFormControl.setValue(null);
    this.onSelectUser.emit(null);
    this.hideList = true;
  }
}
